
function getWindowHostName () {
    let hostName = window.location.hostname;
    return hostName;
}

export default getWindowHostName